<template>
    <college-quire ref="changTab"></college-quire>

</template>

<script>
    import collegeQuire from './collegeInquire'

    export default {
        name: "rankingSearch",
        components: {collegeQuire},
        mounted() {
            this.$refs.changTab.changeTab('second');
        }
    }
</script>

<style scoped>

</style>